import {hasReports as hasReportsQuery} from "../gql/queries";
import {queryGqlApi} from "../../../graphql/queryGqlApi";
import {IDataClientService} from "../../../platform/services/data/DataClientService";
import {IAuthService} from "../../../platform/services/auth/AuthService";

export const hasReports = async (
    dataClientService: IDataClientService,
    authService: IAuthService,
    taskId: string
): Promise<boolean> => {
    const result = await queryGqlApi(
        hasReportsQuery,
        {taskId},
        dataClientService,
        authService,
        'pgServer'
    );
    return !!result;
};
